import React, { useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import CalendarComponent from "../../../components/calendar";
import AppLoader from "../../../components/loader";
import { AppContext } from "../../../lib/Context";
import { getfollowUpDates } from "../../../services/ContractApi";
import { handleOpenSnackBar } from "../../../utils/helper";
import AppHeader from "../../../components/header/index";
import { useNavigate } from "react-router-dom";
import {
  setLeadEndDate,
  setLeadSaleStatusValue,
  setLeadSearchValue,
  setLeadStartDate,
  setProposalSearchValueForAgent,
} from "../../../lib/redux/slices/searchKeysSlice";
import { Box } from "@mui/material";
import { setCurrentPage } from "../../../lib/redux/slices/contractPaginateSlice";

const dropDownStyle = {
  display: "flex",
  overflowY: "auto",
  gap: 0.5,

  "&::-webkit-scrollbar": {
    width: "8px",
    height: "8px",
    display: "none",
  },
  "&::-webkit-scrollbar-thumb": {
    backgroundColor: "primary.main",
    // borderRadius: "4px",
  },
  "&::-webkit-scrollbar-thumb:hover": {
    backgroundColor: "secondary.dark",
  },
  "&::-webkit-scrollbar-track": {
    backgroundColor: "text.coolGrey",
  },
};

const ContractEndDateComponent = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [allFollowUpdates, setAllFollowUpDates] = useState(false);
  const { userData } = useContext(AppContext);

  useEffect(() => {
    getAllFollowUpDates();
  }, []);

  const getAllFollowUpDates = async () => {
    setIsLoading(true);
    try {
      const response = await getfollowUpDates([userData?._id]);
      if (response.data.status === "success") {
        const data = response.data.data;
        const newData = data?.map((x) => ({
          id: x._id,
          type: x.type,
          title: x.userName || "NA",
          businessName: x.businessName || "NA",
          start: new Date(x.contractEndDate),
          end: new Date(x.contractEndDate),
          followUpDate: new Date(x.followUpDate),
          contractEndDate: x.contractEndDate
            ? new Date(x.contractEndDate)
            : null,
          contact: x.contact || "NA",
          agentName: x.agentName || "NA",
          note: x.note || "NA",
          colorCode: x.agentColorCode,
          allDay: true,
          address: x.address || "NA",
        }));

        setAllFollowUpDates(newData);
      } else {
        handleOpenSnackBar(response.data.message, "error");
      }
    } catch (error) {
      handleOpenSnackBar(error?.message, "error");
    } finally {
      setIsLoading(false);
    }
  };

  const handleSelectContractEnd = (data) => {
    if (data.type === "Lead") {
      navigate(`/proposals`);
      dispatch(setProposalSearchValueForAgent(data.id));
    } else {
      navigate(`/all-prospects`);
      dispatch(setLeadSearchValue(data.id));
      dispatch(setLeadStartDate(""));
      dispatch(setLeadEndDate(""));
      dispatch(setLeadSaleStatusValue([]));
      dispatch(setCurrentPage(1));
    }
  };

  return (
    <Box>
      <AppLoader isVisible={isLoading} />

      <CalendarComponent
        data={allFollowUpdates || []}
        onSelectEvent={handleSelectContractEnd}
        title={"Contract End Dates"}
      />
    </Box>
  );
};

export default ContractEndDateComponent;
